<template>
  <main id="about-page">
    <ContentTitle
      :category="$t('sideMenu.ClientInventory')"
      :categoryIcon="'scf-patrimoine'"
      :title="$t('sideMenu.DeviceImportDetail')"
    /><br />

    <div style="max-width: 100%" v-if="componentKey > 0" :key="componentKey">
      <div class="row">
        <div class="ml-15" style="width: 100%; float: left">
          <card
            ref="collapsible"
            enableCollapse=true
            :title="this.$t('pages.DeviceImportList.FileName')"
            :styles="'overflow-none'"
            :fullScreen="false"
          >
            <template v-slot:card-drop-down> </template>

            <template v-slot:card-body-title> </template>

            <template v-slot:card-body-container>
              <div class="row" style="padding-left: 25px">
                <div class="row" style="padding-top: 10px">
                  <div class="col-4">
                    <div class="ElementBox">
                      {{ $t("pages.DeviceImportList.columns.Client") }}:
                    </div>
                    {{ DeviceImportDetails.Client }}
                  </div>
                  <div class="col-4">
                    <div class="ElementBox">
                      {{ $t("pages.DeviceImportList.columns.CreatedDate") }}:
                    </div>
                    {{ format_date(DeviceImportDetails.CreatedDate) }}
                  </div>
                  <div class="col-4">
                    <div class="ElementBox">
                      {{ $t("pages.DeviceImportList.columns.SourceEnum") }}:
                    </div>
                    {{ getTraductionFlux(DeviceImportDetails.SourceEnum) }}
                  </div>
                </div>

                <div class="row" style="padding-top: 10px">
                  <div class="col-4" style="overflow-wrap: break-word">
                    <div class="ElementBox">
                      {{ $t("pages.DeviceImportList.columns.ExternalId") }}:
                    </div>
                    <!-- <a :href="this.downloadInputRoot.concat('', this.DeviceImportDetails.Id)">{{
              DeviceImportDetails.ExternalId
            }}</a> -->
                    <div
                      style="cursor: pointer; color: blue"
                      @click="downloadInputFile"
                    >
                      {{ DeviceImportDetails.ExternalId }}
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="ElementBox">
                      {{
                        $t(
                          "pages.DeviceImportList.columns.ProcessingStatusEnum"
                        )
                      }}:
                      <ToolTip
                        :title="'Tooltip title'"
                        :content="
                          getTraductionState(
                            DeviceImportDetails.ProcessingStatusEnum
                          )
                        "
                      >
                        <div class="scf-help icon"></div>
                      </ToolTip>
                    </div>
                    {{
                      getTraductionState(
                        DeviceImportDetails.ProcessingStatusEnum
                      )
                    }}
                  </div>
                  <div class="col-4" style="overflow-wrap: break-word">
                    <div class="ElementBox">
                      {{
                        $t("pages.DeviceImportList.columns.AcknowlegeFileName")
                      }}:
                    </div>
                    <!-- <a :href="this.downloadAckRoot.concat('', this.DeviceImportDetails.Id)">{{
              DeviceImportDetails.AcknowlegeFileName
            }}</a> -->
                    <div
                      style="cursor: pointer; color: blue"
                      @click="downloadAckFile"
                    >
                      {{ DeviceImportDetails.AcknowlegeFileName }}
                    </div>
                  </div>
                </div>
                <div class="row" style="padding-top: 10px">
                  <div class="col-4">
                    <!-- <div class="ElementBox">
              {{ $t("pages.DeviceImportList.columns.AcknowlegeFileName") }}:
            </div>
            {{ DeviceImportDetails.AcknowlegeFileName }} -->
                  </div>
                  <div class="col-4"></div>
                  <div class="col-4"></div>
                </div>
              </div>
            </template>
            <template v-slot:card-footer>
              <div class="col-12">
                <progressBarRange
                  :Globalfail="false"
                  :ShowValue="false"
                  :Successful="StateCount.Successful"
                  :InProgress="StateCount.InProgress"
                  :Failed="StateCount.Failed"
                  :Pending="StateCount.Pending"
                  :Planned="StateCount.Planned"
                ></progressBarRange>
              </div>
            </template>
          </card>
        </div>
      </div>
      <div
        v-if="$jwt.hasRole('dm-super-admin') && canRetryJoin"
        class="row justify-content-center"
      >
        <div class="col-4 mt-2">
          <div class="card border-warning mb-3">
            <div class="card-header">
              {{ $t("pages.FileProcessingDetails.RetryJoin.TitleCard") }}
            </div>
            <div class="card-body">
              {{ $t("pages.FileProcessingDetails.RetryJoin.TextCard") }}
            </div>
            <div class="card-footer">
              <button
                type="button"
                class="btn btn-outline-danger btn-sm"
                v-on:click="confirmRetryJoin()"
              >
                {{ $t("pages.FileProcessingDetails.RetryJoin.TitleCard") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="row" v-if="gridComponentKey > 0">
        <div style="flex: auto"></div>
        <!-- begin grid -->
        <OdataFlexGrid
          ref="odataGrid"
          :key="gridComponentKey"
          v-if="DeviceImportDetails.Id"
          :Api="{
            base: urlOdata + 'api/v1/OData/',
            controller:
              'DeviceImportReports?deviceImportId=' + DeviceImportDetails.Id,
          }"
          :autoResizeWidth="false"
          :FiltersDefinition="FiltersDefinition"
          :ColumnsDefinition="columns"
          :allowPinning="'SingleColumn'"
          :defaultGroupment="['ReportId']"
          :FilterColumns="[
            'ErrorCode',
            'ReportId',
            'ExternalId',
            'ErrorMessageValues',
            'AlternateExternalId',
            'TypeEnum',
          ]"
          :requestHeaders="gridHeaders"
          :displayLang="culture"
          v-on:initializedGrid="gridInitialized"
          v-on:gridFilterChanged="gridFilterChanged"
          :GridId="'DeviceImportDetail_v5'"
          :ExportsButtons="{
            Header: ExportsHeader,
            DataSource: ExportsDataSource,
            Events: ExportsEvents,
          }"
          :WijmoLicense="config.value('VUE_APP_WIJMO_LICENCE')"
          v-on:format-columns="formatColumns"
          v-on:column-visibility-changed="gridComponentKey++"
          :enableColumnCache="false"
        />
        <!-- end grid -->
      </div>
    </div>
    <loaderSpinner :loading="isLoading"></loaderSpinner>
  </main>
</template>

<script>
import { defineComponent, computed } from "vue";
import Configs from "../../configs";
import Swal from "sweetalert2";
import MainService from "../services/MainService";
import ClientService from "../services/ClientService";
import "@grapecity/wijmo.vue2.gauge";
import * as wijmo from "@grapecity/wijmo";
import utils from "../Utils/libraries";
import progressBarRange from "../components/progressBarRange.vue";
import Helper from "@/Utils/Helper";

import OdataFlexGrid from "@supervision/vue-components/components/OdataFlexGrid.vue";
import LoaderSpinner from "../components/LoadingSpinner.vue";
import ContentTitle from "@supervision/vue-components/components/ContentTile";
import ToolTip from "@supervision/vue-components/components/Tooltip.vue";
import card from "@supervision/vue-components/components/Card.vue";

export default defineComponent({
  name: "filedetail",
  inject: ["routePrefix", "accessToken", "currentScope"],
  components: {
    OdataFlexGrid,
    LoaderSpinner,
    ContentTitle,
    progressBarRange,
    ToolTip,
    card,
  },
  watch: {
    currentScope: {
      handler: function (newVal) {
        if (newVal) {
          this.currentScopeView = newVal;
          this.mainService = new MainService(this.$jwt.token, newVal);
          this.clientService = new ClientService(this.$jwt.token, newVal);
          this.initComponent();
          this.componentKey += 1;
          this.gridComponentKey += 1;
        }
      },
      deep: true,
    },
    accessToken(newVal) {
      if (newVal) {
        this.mainService = new MainService(newVal, this.currentScopeView);
        this.clientService = new ClientService(newVal, this.currentScopeView);
      }
    },
    culture(newVal) {
      this.mainService
        .getMessageErrorCode(newVal)
        .then((errorsMessages) => {
          this.errorMessages =
            this.GetCardDetailsWithoutTranslate(errorsMessages);
        })
        .then(() => {
          if (this.currentScopeView != null && this.currentScopeView !== "")
            this.gridComponentKey += 1;
        });
    },
    StateCount: {
      handler() {
        if (this.currentScopeView != null && this.currentScopeView !== "")
          this.componentKey += 1;
      },
      deep: true,
    },
  },
  data() {
    return {
      gridHeaders: {
        authorization: `bearer ${this.accessToken}`,
        "X-Current-Scope": computed(() =>
          this.isPreselectedScope
            ? this.preselectedScope
            : this.currentScopeView
        ),
        "X-Custom-Filters": computed(() => this.headerFilters),
      },
      gridComponentKey: 0,
      componentKey: 0,
      errorCodes: [],
      mainService: null,
      clientService: null,
      config: Configs,
      errorMessages: null,
      errorMessagesEN: null,
      urlOdata: Configs.value("VUE_APP_WEBAPI"),
      culture: computed(() => this.$i18n.locale),
      DeviceImportDetails: {
        Id: null,
        CreatedDate: new Date(),
        SourceEnum: null,
        ExternalId: null,
        ProcessingStatusEnum: null,
        AcknowlegeFileName: null,
        Records: null,
        RecordsOk: null,
        RecordsKo: null,
        Client: null,
      },
      Successful: 0,
      InProgress: 0,
      Failed: 0,
      Pending: 0,
      Planned: 0,
      isLoading: false,
      gauge: null,
      theGrid: null,
      latestDataState: null,
      filter: null,
      loading: true,
      rowsCount: 0,
      Globalfail: false,
      receivedData: null,
      StateCount: {
        Successful: 0,
        InProgress: 0,
        Failed: 0,
        Pending: 0,
        Planned: 0,
      },
      canRetryJoin: false,
      FiltersDefinition: [
        {
          binding: "ErrorCode",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: computed(() => this.errorCodes),
        },
        {
          binding: "ReportId",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "ExternalId",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "AlternateExternalId",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TypeEnum",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: [
            {
              id: "Transmitter",
              label: computed(() => this.getTraductionType("Transmitter")),
            },
            {
              id: "Sensor",
              label: computed(() => this.getTraductionType("Sensor")),
            },
            {
              id: "Asset",
              label: computed(() => this.getTraductionType("Asset")),
            },
          ],
        },
      ],
      ExportsHeader: { text: "Exports", icon: "scf-export" },
      ExportsDataSource: [
        { text: "Export as Csv", method: "exportCsv", icon: "scf-csv" },
        { text: "Export as Excel", method: "exportExcel", icon: "scf-excel" },
      ],
      ExportsEvents: {
        exportCsv: this.exportCsv,
        exportExcel: this.exportExcel,
      },
      columns: [
        {
          binding: "Id",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceImportDetailList.columns.Id")
          ),
          visible: false,
          isTechnicalColumn: true,
        },
        {
          binding: "DeviceId",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceImportDetailList.columns.DeviceId")
          ),
          visible: false,
          isTechnicalColumn: true,
        },
        {
          binding: "ReportId",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceImportDetailList.columns.ReportId")
          ),
        },
        {
          binding: "ExternalId",
          width: "2*",
          header: computed(() =>
            this.$t("pages.DeviceImportDetailList.columns.ExternalId")
          ),
        },
        {
          binding: "AlternateExternalId",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceImportDetailList.columns.AlternateExternalId")
          ),
          visible: false,
        },
        {
          binding: "ErrorCode",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceImportDetailList.columns.ErrorCode")
          ),
        },
        {
          binding: "TypeEnum",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceImportDetailList.columns.TypeEnum")
          ),
        },
        {
          binding: "ErrorMessageValues",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceImportDetailList.columns.ErrorMessageValues")
          ),
          visible: false,
          isTechnicalColumn: true,
        },

        {
          header: computed(() =>
            this.$t("pages.DeviceImportDetailList.columns.Details")
          ),
          width: "2*",
        },
      ],
      exportRoot:
        Configs.value("VUE_APP_WEBAPI") +
        "api/v1/OData/DeviceImportReports/export?",
      downloadAckRoot:
        Configs.value("VUE_APP_WEBAPI") +
        "api/v1/DeviceImports/deviceImportAcknowlegeContent?deviceImportId=", //https://localhost:44392/api/v1/DeviceImports/deviceImportAcknowlegeContent?deviceImportId=
      downloadInputRoot:
        Configs.value("VUE_APP_WEBAPI") +
        "api/v1/DeviceImports/deviceImportContent?deviceImportId=",
    };
  },
  methods: {
    onGroupingLimited({ maxRows, total }) {
      Swal.fire({
        title: this.$t("components.odataflexgrid.onGroupingLimited.Title"),
        html: this.$t("components.odataflexgrid.onGroupingLimited.Text", {
          maxRows: maxRows,
          total: total,
        }),
        showConfirmButton: false,
        timer: maxRows,
        icon: "warning",
      });
    },
    resizeGrid() {
      this.$nextTick(() => {
        this.$refs.odataGrid.computeHeight();
      });
    },
    downloadInputFile() {
      this.isLoading = true;
      this.mainService
        .Export(this.downloadInputRoot.concat("", this.DeviceImportDetails.Id))
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.Download(
            this.DeviceImportDetails.ExternalId,
            type,
            response.data,
            false
          );
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    downloadAckFile() {
      this.isLoading = true;
      this.mainService
        .Export(this.downloadAckRoot.concat("", this.DeviceImportDetails.Id))
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.Download(
            this.DeviceImportDetails.AcknowlegeFileName,
            type,
            response.data,
            false
          );
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    ResetProgressBar() {
      this.StateCount.Pending = 0;
      this.StateCount.Successful = 0;
      this.StateCount.Failed = 0;
      this.StateCount.InProgress = 0;
      this.StateCount.Planned = 0;
    },
    gridFilterChanged(data) {
      this.latestDataState = data;
    },
    gridInitialized(flexgrid) {
      this.theGrid = flexgrid;
      this.theGrid.loadingRows.addHandler(() => (this.loading = true));
      this.theGrid.loadedRows.addHandler(() => (this.loading = false));

      var SearchReference = localStorage.getItem("SearchReference");
      console.log("searchrefe " + SearchReference);
      if (
        SearchReference !== "undefined" &&
        SearchReference != "" &&
        SearchReference != null
      ) {
        this.theGrid.collectionView.filterDefinition = `(contains(ExternalId,'${SearchReference}')) or (contains(AlternateExternalId,'${SearchReference}'))`;
      }

      this.loadLayout();

      var RedirectToEquipement = this.RedirectToEquipementDetails.bind(this);
      flexgrid.hostElement.addEventListener("click", function (e) {
        let action = e.target.getAttribute("action-type-ExternalId");
        if (!action) {
          return;
        }
        var hitTest = flexgrid.hitTest(e);
        var data = flexgrid.rows[hitTest.row].dataItem;
        RedirectToEquipement(data.ExternalId);
      });
    },
    loadLayout() {
      let layout = localStorage.getItem("DeviceImportDetails");
      if (layout) {
        this.columns = JSON.parse(layout).columns;
      }
    },
    handleResize() {
      wijmo.Control.refreshAll();
    },
    saveLayout() {
      localStorage.setItem("DeviceImportDetails", this.theGrid.columnLayout);
    },
    exportExcel() {
      const filter =
        this.latestDataState !== null && this.latestDataState !== undefined
          ? this.latestDataState.filterDefinition
          : "";
      let exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&exporFormat=excel&deviceImportId=${this.DeviceImportDetails.Id}`;
      if (filter != "") {
        exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=excel&deviceImportId=${this.DeviceImportDetails.Id}`;
      }

      this.isLoading = true;
      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes(
            this.$t("sideMenu.DeviceImportDetail"),
            type,
            "xlsx",
            response.data
          );
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    exportCsv() {
      const filter =
        this.latestDataState !== null && this.latestDataState !== undefined
          ? this.latestDataState.filterDefinition
          : "";
      let exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&exporFormat=csv&deviceImportId=${this.DeviceImportDetails.Id}`;
      if (filter != "") {
        exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=csv&deviceImportId=${this.DeviceImportDetails.Id}`;
      }

      console.log(exportUrl);
      this.isLoading = true;
      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes(
            this.$t("sideMenu.DeviceImportDetail"),
            type,
            "csv",
            response.data
          );
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.isLoading = false;
        });
    },

    format_date(value) {
      return this.$d(value, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
      // if (value) {
      //   if (this.$i18n.locale == "fr-FR")
      //     return moment(String(value)).format("DD/MM/YYYY");
      //   else return moment(String(value)).format("MM/DD/YYYY");
      // }
    },
    GetCardDetailsWithoutTranslate(t) {
      return Object.entries(t).map((el) => {
        return {
          key: el[0],
          value: el[1],
        };
      });
    },

    formatColumns: function (s, e) {
      const flex = s;
      if (e.panel == flex.cells) {

        const item = flex.rows[e.row]?.dataItem;
        if (!item) return; 

        if (item.name) return;
        
        if (flex.columns[e.col].header == "Actions") {
          e.cell.innerHTML =
            wijmo.format(
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style="margin-left:5px" class="bi bi-trash" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/><path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/></svg>',
              s.rows[e.row].dataItem
            ) +
            wijmo.format(
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style="margin-left:5px" class="bi bi-arrow-repeat" viewBox="0 0 16 16"><path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/><path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/></svg>',
              s.rows[e.row].dataItem
            ) +
            wijmo.format(
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style="margin-left:5px" class="bi bi-search" viewBox="0 0 16 16"><path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/></svg>',
              s.rows[e.row].dataItem
            );
        } else if (
          flex.columns[e.col].header == "Details" ||
          flex.columns[e.col].header == "Détails"
        ) {
          if (s.rows[e.row].dataItem.ErrorCode == null) {
            e.cell.innerHTML = item.Id ? "OK" : "";
          } else
            e.cell.innerHTML = wijmo.format(
              this.GetMessageError(
                s.rows[e.row].dataItem.ErrorCode,
                s.rows[e.row].dataItem.ErrorMessageValues,
                this.errorMessages
              ),
              s.rows[e.row].dataItem
            );
        } else if (
          flex.columns[e.col].binding == "ExternalId" ||
          flex.columns[e.col].binding == "AlternateExternalId"
        ) {
          e.cell.innerHTML = wijmo.format(
            '<i action-type-ExternalId="RedirectToEquipementDetails">' +
              e.cell.textContent.trim() +
              "</i>",
            s.rows[e.row].dataItem
          );
        } else if (flex.columns[e.col].binding == "ErrorCode") {
          if (s.rows[e.row].dataItem.ErrorCode == null) {
            e.cell.innerHTML = item.Id ? "OK" : "";
          }
        } else if (
          flex.columns[e.col].header == "Corrective Actions" ||
          flex.columns[e.col].header == "Action Corrective"
        ) {
          if (s.rows[e.row].dataItem.ErrorCode == null) {
            e.cell.innerHTML = item.Id ? "OK" : "";
          }
        } else if (
          flex.columns[e.col].binding == "TypeEnum" &&
          s.rows[e.row].dataItem.TypeEnum
        ) {
          e.cell.innerHTML = this.$t(
            `DeviceType.${s.rows[e.row].dataItem.TypeEnum}`
          );
        }
      }
    },
    getTraductionFlux: function (e) {
      return this.tryGetTranslation(`pages.DeviceImportList.Source.${e}`);
    },
    getTraductionState: function (e) {
      return this.tryGetTranslation(`pages.DeviceImportList.State.${e}`);
    },
    getTraductionType: function (e) {
      return this.tryGetTranslation(`pages.FileProcessingDetails.Type.${e}`);
    },
    tryGetTranslation(key) {
      return typeof this.$tm(key) == "string" ? this.$t(key) : key;
    },
    showmessage() {
      Swal.fire("functionality not yet specified", "", "info");
    },
    confirmRetryJoin() {
      Swal.fire({
        title: this.$t("pages.FileProcessingDetails.RetryJoin.TitleConfirm"),
        text: this.$t("pages.FileProcessingDetails.RetryJoin.TextConfirm", {
          file: this.DeviceImportDetails.ExternalId,
        }),
        icon: "warning",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: this.$t("common.confirm"),
        denyButtonText: this.$t("common.cancel"),
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: this.$t(
              "pages.FileProcessingDetails.RetryJoin.TitleLoading",
              { file: this.DeviceImportDetails.ExternalId }
            ),
          });
          Swal.showLoading();
          this.clientService
            .retryJoinAndAck(
              this.DeviceImportDetails.Client,
              this.DeviceImportDetails.ExternalId
            )
            .then((res) => {
              if (typeof res === "boolean" && res) {
                Swal.close();
                Swal.fire({
                  icon: "success",
                  title: this.$t(
                    "pages.FileProcessingDetails.RetryJoin.TitleSuccess"
                  ),
                  text: this.$t(
                    "pages.FileProcessingDetails.RetryJoin.TextSuccess",
                    { file: this.DeviceImportDetails.ExternalId }
                  ),
                  confirmButtonText: "OK",
                });
              } else {
                Swal.close();
                Swal.fire({
                  icon: "error",
                  title: this.$t(
                    "pages.FileProcessingDetails.RetryJoin.TitleFailed"
                  ),
                  text: this.$t(
                    "pages.FileProcessingDetails.RetryJoin.TextFailed",
                    { file: this.DeviceImportDetails.ExternalId }
                  ),
                  confirmButtonText: "OK",
                });
              }
              this.canRetryJoin = false;
            });
        }
      });
    },
    RedirectToEquipementDetails(e) {
      let self = this;
      //TODO recupere la liste des equipements
      //TODO Vérifier si la reference existe, si existe redirection vers la page details d'équipement, sinon afficher un message swal
      this.mainService
        .getdevicesByExternalId(e)
        .then((data) => {
          if (data == null || data == undefined || data == "") {
            Swal.fire({
              title: "",
              icon: "info",
              html:
                this.$t("pages.DeviceImportDetailList.popup.DeviceNotFound") +
                " <b>" +
                e +
                "</b>.",
              focusConfirm: false,
            });
          } else {
            localStorage.setItem("deviceId", data.id);
            localStorage.setItem("deviceType", data.type);
            localStorage.setItem("deviceSubType", data.subType);
            localStorage.setItem("externalId", data.externalId);

            const prefix = Helper.ComputeRoutePrefix(this.routePrefix);

            self.$router.push({
              path: `${prefix}/DmPortal/equipmentdetail/${this.currentScopeView}/${data.type}/${data.id}`,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire(this.$t("pages.FirmwareAdd.ErrorLabel.Error"));
        });
    },
    updateStateProgressBar() {
      this.ResetProgressBar();
      // this.StateCount.Failed = 5;

      if (
        this.DeviceImportDetails.ProcessingStatusEnum == "PartiallySuccessful"
      ) {
        this.StateCount.InProgress = 1; //vert
      } else if (
        this.DeviceImportDetails.ProcessingStatusEnum == "Successful"
      ) {
        this.StateCount.Successful = 1; //vert foncé
      } else if (
        this.DeviceImportDetails.ProcessingStatusEnum == "InProgress"
      ) {
        this.StateCount.Planned = 1; //gray
      } else {
        //Failed
        this.StateCount.Failed = 1; // rouge
      }
    },
    GetMessageError(errorCode, params, messagesList) {
      if (errorCode !== null && errorCode != "") {
        var concernedMsg = messagesList.filter(
          (e) => e.key == `ErrorMessage_${errorCode}`
        );

        var message = concernedMsg.length > 0 ? concernedMsg[0].value : "";

        if (params !== null) {
          var paramsArray = params.split(";");
          if (paramsArray.length > 1) {
            for (let i = 0; i < paramsArray.length; i++) {
              if (i == 0) {
                message = message.replace(
                  `{${i}}`,
                  !this.isNotFound(
                    this.$t("pages.DeviceDetails." + paramsArray[i])
                  )
                    ? this.$t("pages.DeviceDetails." + paramsArray[i])
                    : paramsArray[i]
                );
              } else {
                message = message.replace(`{${i}}`, paramsArray[i]);
              }
            }
          } else if (paramsArray.length == 1) {
            message = message.replace(`{0}`, paramsArray[0]);
          }

          return message;
        }
        return message;
      }
      return "";
    },
    isNotFound(e) {
      return e.includes(".");
    },
    pushErrorCodesFilter() {
      const ignoredErrorCodes = ["InactiveClient", "MissedErrorMessage"];
      this.errorCodes.push({
        id: null,
        label: "OK",
      });
      for (const errorMsg of this.errorMessages) {
        const errorCode = errorMsg.key.replace("ErrorMessage_", "");
        if (ignoredErrorCodes.includes(errorCode)) continue;

        this.errorCodes.push({
          id: errorCode,
          label: errorCode,
        });
      }
    },
    async initComponent() {
      let errorsMessages = await this.mainService.getMessageErrorCode(
        this.culture
      );

      this.errorMessages = this.GetCardDetailsWithoutTranslate(errorsMessages);
      this.pushErrorCodesFilter();
      console.log(this.errorMessages);

      let id = this.$route.params.id;
      var devicesImport = await this.mainService.getFileProcessing(id);
      let fileProcessing = devicesImport[0];

      if (fileProcessing) {
        this.DeviceImportDetails = {
          Id: fileProcessing.Id,
          CreatedDate: fileProcessing.CreatedDate,
          SourceEnum: fileProcessing.SourceEnum,
          ExternalId: fileProcessing.ExternalId,
          ProcessingStatusEnum: fileProcessing.ProcessingStatusEnum,
          AcknowlegeFileName: fileProcessing.AcknowlegeFileName,
          Records: fileProcessing.Records,
          RecordsOk: fileProcessing.RecordsOk,
          RecordsKo: fileProcessing.RecordsKo,
          Client: fileProcessing.Client,
        };
        this.canRetryJoin =
          this.DeviceImportDetails.ProcessingStatusEnum == "InProgress" &&
          this.DeviceImportDetails.SourceEnum == "Assets";
      }
      this.updateStateProgressBar();
    },
  },
  mounted() {
    this._onGlobalCollapseShown = (e) => {
      if (e.target && e.target.id && e.target.id.startsWith("collapse")) {
        this.resizeGrid();
      }
    };
    this._onGlobalCollapseHidden = (e) => {
      if (e.target && e.target.id && e.target.id.startsWith("collapse")) {
        this.resizeGrid();
      }
    };
    document.addEventListener("shown.bs.collapse", this._onGlobalCollapseShown);
    document.addEventListener(
      "hidden.bs.collapse",
      this._onGlobalCollapseHidden
    );
    const e = new CustomEvent("component-ready");
    window.dispatchEvent(e);
  },
  beforeUnmount() {
    if (this._onGlobalCollapseShown) {
      document.removeEventListener(
        "shown.bs.collapse",
        this._onGlobalCollapseShown
      );
    }
    if (this._onGlobalCollapseHidden) {
      document.removeEventListener(
        "hidden.bs.collapse",
        this._onGlobalCollapseHidden
      );
    }
  },
  beforeCreate() {
    const preselectedScope = this.$route.params["scope"];
    this.currentScopeView =
      preselectedScope?.length > 1
        ? preselectedScope
        : this.currentScope ?? this.$jwt.scope;
  },
  created() {
    if (this.currentScopeView != null) {
      this.mainService = new MainService(
        this.$jwt.token,
        this.currentScopeView
      );
      this.clientService = new ClientService(
        this.$jwt.token,
        this.currentScopeView
      );
      if (this.currentScopeView == "ALL") {
        this.initComponent();
        this.componentKey++;
        this.gridComponentKey += 1;
      }
    }
    window.addEventListener("resize", this.handleResize);
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize);
  },
});
</script>

<style scoped src="../assets/css/campaignDetail.css"></style>

<style lang="scss" scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";

#about-page {
  font-family: "D-DIN" !important;
}

.title-Card {
  font-family: "D-DIN-900" !important;
}

.bg-successful {
  --bs-bg-opacity: 1;
  background-color: #6b8e23 !important;
}

.bg-inProgress {
  --bs-bg-opacity: 1;
  background-color: #8fce00 !important;
}

.bg-failed {
  --bs-bg-opacity: 1;
  background-color: #f44336 !important;
}

.bg-pending {
  --bs-bg-opacity: 1;
  background-color: #d3d3d3 !important;
}

.bg-planned {
  --bs-bg-opacity: 1;
  background-color: #3aa9e2 !important;
}
</style>
